import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Badge.module.css';

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';
export type BadgePurpose = 'status' | 'type';

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: BadgeTone;
  purpose?: BadgePurpose;
  children: ReactNode;
};

export function Badge({
  tone = 'neutral',
  purpose = 'status',
  className,
  children,
  ...rest
}: BadgeProps) {
  return (
    <span className={cx(styles.badge, styles[purpose], styles[tone], className)} {...rest}>
      {children}
    </span>
  );
}
